import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Filter } from './Devices'
import { Get } from './Get'
import { UserProfileObject } from './organization.types'
import { Post } from './Post'
import { Put } from './Put'

export interface UserResponse {
  id: string
  invitationStatus: string
  userName: string
  email: string
  phoneNumber: string
  firstname: string
  lastname: string
  avatarUrl: string
  forcePasswordChange: boolean
  profile: any
  userOrgId: string
  organizationRoles: string[]
  gender: string
  isActive?: boolean
}

export interface PageUserResponse {
  results: UserResponse[]
  page: number
  pageCount: number
  pageSize: number
  queryCount: number
  firstRowIndex?: number
  lastRowIndex?: number
}

export interface UpdateUserData {
  firstName?: string
  lastName?: string
  email?: string
  password?: string
  confirmPassword?: string
}

export interface GetUsersParams {
  page?: number
  pageSize?: number
}

class UserServiceController {
  private licenseManagerUrl =
    process.env.LICENSE_MANAGER_URL ??
    window.location.protocol +
      '//' +
      window.location.hostname +
      '/license_manager'

  private userServerUrl = `${this.licenseManagerUrl}/users`

  public Get = {
    getAllUsers: (params?: GetUsersParams): AxiosPromise<PageUserResponse> => {
      const { page = 1, pageSize = 10 } = params || {}
      const url = `${this.userServerUrl}?page=${page}&pageSize=${pageSize}`
      return Get(url)
    },
    getRolesToUserId: (userId: string): AxiosPromise<string[]> => {
      const url = `${this.userServerUrl}/${userId}/roles`
      return Get(url)
    },
  }

  public Put = {
    updateRolesUser: (userId: string, data: { roleName: string }) => {
      const url = `${this.licenseManagerUrl}/users/${userId}/roles`
      return Put(url, data)
    },
    blockUser: (userId: string): AxiosPromise<any> => {
      const url = `${this.licenseManagerUrl}/users/deactivate`
      return Put(url, [userId])
    },
    unblockUser: (userId: string): AxiosPromise<any> => {
      const url = `${this.licenseManagerUrl}/users/activate`
      return Put(url, [userId])
    },
  }

  public Delete = {
    deleteRolesUser: (userId: string, roleNames: string[]) => {
      const url = `${this.licenseManagerUrl}/users/${userId}/roles`
      return Delete(url, roleNames)
    },
    deleteOrganization: (organizationId: string): AxiosPromise<any> => {
      const url = `${this.licenseManagerUrl}/organizations/${organizationId}`
      return Delete(url)
    },
    removeUserFromOrganization: (
      organizationId: string,
      userId: string
    ): AxiosPromise<any> => {
      const url = `${this.licenseManagerUrl}/organizations/${organizationId}/users`
      const data = [userId]
      return Delete(url, data)
    },
  }

  public Post = {
    createUser: (data: any) => {
      const url = `${this.licenseManagerUrl}/organizations/users/register`
      return Post(url, data)
    },
  }
}

export const UserService = new UserServiceController()